import moment from "moment";
import {formatPrices} from "../../../../common/utils/helpers";

export const paiementSouscriptionTableColumns = [
  {
    field: "numFactura",
    headerName: "Numéro de la facture",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.numFactura ?? "-",
  },
  {
    field: "tipo",
    headerName: "Type",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => "Principale",
  },
  {
    field: "fechaEmision",
    headerName: "Date de la facture",
    flex: 1.2,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) =>
      Boolean(row.fechaEmision)
        ? moment(row.fechaEmision).format("DD/MM/YYYY LT")
        : "-",
  },
  {
    field: "fechaVencimiento",
    headerName: "Date d'échéance de règlement",
    flex: 1.2,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) =>
      Boolean(row.fechaVencimiento)
        ? moment(row.fechaVencimiento).format("DD/MM/YYYY")
        : "-",
  },
  {
    field: "importeHT",
    headerName: "Montant HT",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => `${formatPrices(row.importeHT)} MAD` ?? "-",
  },
  {
    field: "importeTTC",
    headerName: "Montant TTC",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => `${formatPrices(row.importeTTC)} MAD` ?? "-",
  },
  {
    field: "estado.descripcion",
    headerName: "Statut facture",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.estado.descripcion ?? "-",
  },
];
